import {TouchableOpacity, Platform, Animated} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import styled from 'styled-components/native';

interface ContainerProps {
  selected?: boolean;
}

//@ts-ignore
export const Container = styled(TouchableOpacity)<ContainerProps>`
  position: relative;
  z-index: 2;
  padding: ${RFValue(10)}px 24px;
  border-radius: ${RFValue(12)}px;
  flex-direction: row;
  align-items: center;
  border-width: 1px;
  border-color: ${({theme, selected}) =>
    selected ? theme.colors.blue : theme.colors.border2};
  justify-content: space-between;
`;

export const PulseWrapper = styled.View`
  position: relative;
  overflow: visible;
`;

export const PulseHalo = styled(Animated.View)`
  position: absolute;
  z-index: 0;
  elevation: 0;
  top: ${RFValue(-4)}px;
  left: ${RFValue(-4)}px;
  right: ${RFValue(-4)}px;
  bottom: ${RFValue(-4)}px;
  border-radius: ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.blue};
  z-index: 0;
  ${Platform.OS === 'ios'
    ? `
      shadow-opacity: 0.35;
      shadow-radius: ${RFValue(12)}px;
      shadow-offset: 0px 0px;
    `
    : ''}
  shadow-color: ${({theme}) => theme.colors.blue};
`;

export const LeftContent = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const Infos = styled.View<{noLeftMargin?: boolean}>`
  margin-left: ${({noLeftMargin}) => (noLeftMargin ? 0 : RFValue(12))}px;
  flex: 1;
`;

export const Installment = styled.View`
  width: ${RFValue(24)}px;
  height: ${RFValue(16)}px;
  background: transparent;
  border-radius: ${RFValue(10)}px;
  align-items: flex-start;
  justify-content: center;
`;

export const Count = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
`;

export const Values = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const Value = styled.Text`
  font-size: ${RFValue(12)}px;
  margin-right: ${RFValue(6)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
`;

export const RightContent = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const TotalValue = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.text};
`;

export const SelectInstallment = styled.View``;

export const ArrowRight = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
`;
